import React, { useState, useEffect } from 'react';
import { updateUser } from '../../services/AdminUserService';
import { validateUser } from '../../../users/validations/admin/AdminUserValidation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import UserEditForm from '../../forms/users/UserEditForm';
import '../../styles/AdminModal.css';

const UserEditModal = ({ isOpen, onClose, onSuccess, user }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isFormValid = formData.first_name.trim() !== '' && formData.last_name.trim() !== '';
  const hasChanges = user && (
    user.first_name !== formData.first_name ||
    user.last_name !== formData.last_name
  );
  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
      });
      setErrors({});
    }
  }, [user]);

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: capitalizeFirstLetter(value) });
  };

  const handleSave = async () => {
    const validationErrors = validateUser(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrors({});
    setError('');

    const { first_name, last_name } = formData;

    try {
      await updateUser(user.id, { first_name, last_name });
      await onSuccess();
    } catch (error) {
      setError('Error updating user. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Edit User</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="admin__modal-body">
          <UserEditForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button
            className="button"
            onClick={handleSave}
            disabled={loading || !isFormValid || !hasChanges}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserEditModal;